import { Component, Element, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'dealer-listing-kbb-rating',
  styleUrl: 'dealer-listing-kbb-rating.css',
  shadow: true,
})
export class DealerListingKbbRating {
  @Element() el: HTMLElement;
  @Prop() ratingInline: string = '';
  @Prop() ratingOverlay: string = '';

  openModal(event: MouseEvent) {
    event.preventDefault();
    const modal = this.el.shadowRoot.querySelector('ico-modal#dealer-listing-kbb-rating-modal') as HTMLIcoModalElement;
    modal.open();
  }

  render() {
    return (
      <Host>
        <div
          data-testid="kbb-rating"
          id="dealer-listing-kbb-rating-inline"
          onClick={(e) => {
            this.openModal(e);
          }}
          class="cursor-pointer w-fit">
          <div>
            <iframe src={this.ratingInline} width="300" height="30" style={{ border: 'none', pointerEvents: 'none' }}></iframe>
          </div>
        </div>
        <ico-modal data-testid="modal-kbb-rating" slot="modal" id="dealer-listing-kbb-rating-modal" displayX={true}>
          <div slot="main" class="">
            <iframe src={this.ratingOverlay} width="100%" height="375" style={{ border: 'none', overflow: 'visible' }}></iframe>
          </div>
        </ico-modal>
      </Host>
    );
  }
}
